
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neat-features",
      function () {
        return require("private-next-pages/neat-features.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neat-features"])
      });
    }
  